/**
 * File: nameplatePage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v4.0.1
 * Created: 2025-12-04
 * Last Updated: 2026-02-18
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Images
import uiDashboard from "../../assets/images/ui-dashboard.svg";
import uiHero from "../../assets/images/ui-hero.jpg";

// Icons
import { FaLock } from "react-icons/fa6";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { FaShieldHalved } from "react-icons/fa6";
import { MdMarkEmailRead } from "react-icons/md";

// Nameplate Page
export const nameplatePage = {
    meta: {
        id: "nameplate-page",
    },
    hero: {
        image: uiHero,
        headline: "Smarter MEP Calculations Sheets",
        subheadline:
            "Stop maintaining internal tools - Save time and standardize your project calculations",
        primaryButton: {
            text: "Get Started",
            type: "primary",
        },
        secondaryButton: {
            text: "Send Inquiry",
            type: "secondary",
        },
    },
    planCard: {
        title: "Subscription Plans",
        plans: [
            {
                id: "plan-sx-1",
                header: "Annual Subscription",
                cost: 450,
                currency: "USD",
                model: "/seat",
            },
            {
                id: "plan-sx-2",
                header: "Monthly Subscription",
                cost: 50,
                currency: "USD",
                model: "/seat",
            },
        ],
        features: [
            {
                id: "feature-sx-1",
                icon: <FaRegCalendarCheck />,
                text: "30-Day Money-Back Guarantee",
            },
            {
                id: "feature-sx-2",
                icon: <MdMarkEmailRead />,
                text: "Priority Email Support",
            },
            {
                id: "feature-sx-3",
                icon: <FaShieldHalved />,
                text: "Enterprise-grade Security",
            },
            {
                id: "feature-sx-4",
                icon: <FaLock />,
                text: "100% Data Privacy",
            },
        ],
    },
    articles: [
        {
            id: "article-sx-1",
            reverse: false,
            image: uiDashboard,
            headline: "No More Outdated Internal Tools",
            description:
                "Say goodbye to error-prone Excel files and custom scripts. Our cloud-based calculation sheets are always up-to-date, version-controlled, and built for modern HVAC and plumbing workflows.",
        },
        {
            id: "article-sx-2",
            reverse: true,
            image: uiDashboard,
            headline: "Organize and Standardize Project Calculations",
            description:
                "Keep all your project calculations in one structured, searchable platform. Ensure consistency across your team and improve collaboration with clearly documented inputs and outputs.",
        },
        {
            id: "article-sx-3",
            reverse: false,
            image: uiDashboard,
            headline: "Save Time and Focus on Engineering",
            description:
                "Automate repetitive calculations and reduce manual work. Free up time for real engineering decisions while increasing accuracy and speed across the team.",
        },
    ],
    faq: [
        { id: "faq-sx-1", header: "Section 1", content: "Content 1" },
        { id: "faq-sx-2", header: "Section 2", content: "Content 2" },
        { id: "faq-sx-3", header: "Section 3", content: "Content 3" },
        { id: "faq-sx-4", header: "Section 4", content: "Content 4" },
        { id: "faq-sx-5", header: "Section 5", content: "Content 5" },
        { id: "faq-sx-6", header: "Section 6", content: "Content 6" },
    ],
    cta: {
        label: "Explore MEP Calculation Tools",
        headline: "Ditch the Spreadsheets for Good",
        description:
            "Join teams replacing outdated tools with purpose-built MEP calculation software. Stay organized, save time, and focus on design - not maintenance.",
    },
};
